export default __webpack_public_path__ + "static/media/icon-otp-two.81c5388a.png";